import { Box } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { PropsWithChildren, PropsWithClassName } from 'lib-shared-types-utils';
import { useCallback, useEffect, useState } from 'react';

import { FieldToggleBoxHead } from './fieldToggleBoxHead';
import styles from './toggleBox.module.scss';
import type { ToggleBoxHeadProps as ToggleBoxHeadProps } from './toggleBoxHead';
import { ToggleBoxHead } from './toggleBoxHead';

interface ToggleBoxProps
  extends ToggleBoxHeadProps, PropsWithClassName, PropsWithChildren {
  isOpen: boolean;
  headComponent: typeof ToggleBoxHead | typeof FieldToggleBoxHead;
  headClassName?: string;
  disabled?: boolean;
}

export function ToggleBox({
  className,
  headComponent: Head,
  headClassName,
  title,
  textProps,
  helpIcon,
  isOpen: propsIsOpen,
  onChange: propsOnChange,
  input,
  children,
  disabled,
}: ToggleBoxProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(propsIsOpen);
  const onChange = useCallback(
    (isOpen: boolean) => {
      propsOnChange?.(isOpen);
      setIsOpen(isOpen);
    },
    [propsOnChange, setIsOpen],
  );

  useEffect(() => {
    setIsOpen(propsIsOpen);
  }, [propsIsOpen]);

  return (
    <Box background="neutral.100" borderRadius="100" className={className}>
      <Head
        title={title}
        isOpen={isOpen}
        onChange={onChange}
        input={input}
        textProps={textProps}
        helpIcon={helpIcon}
        className={headClassName}
        disabled={disabled}
      />
      <div
        className={classnames(styles.children, {
          [styles.childrenIsOpen]: isOpen,
        })}
      >
        {children}
      </div>
    </Box>
  );
}
